import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const SalesCostList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  initialState,
  columnVisibilityModel
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '판매 계정별 리스트' },
          }}
          loading={loading}
          editMode="row"
          initialState={initialState}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default SalesCostList;
